<template>
    <div style="display:inline-block;">

        <v-popover
            offset="16"
            :options="options"
            style="display:inline-block;"
            :open="show"
            placement="left"
        >
            <!-- This will be the popover target (for the events and position) -->
            <button class="tooltip-target b3" style="display:inline-block;" @mouseover="show = true" @mouseleave="show = false">
                <i class="fas fa-calculator fa-fw" />
            </button>

            <!-- This will be the content of the popover -->
            <template slot="popover">

                    <div style="background:#172b43;color:#fff;padding:5px 10px;text-align:center;margin-bottom:10px;border-radius:4px;">
                        <b>BUDGET</b>
                    </div>
                    
                    <div class="line good">
                        <div class="left">Forv. omsætning</div>
                        <div class="right good">{{ project.calculation_price ? project.calculation_price : 0 | realCurrency }}</div>
                    </div>

                    <div class="line bad">
                        <div class="left">Forv. kostpris</div>
                        <div class="right bad">{{ project.calculation_cost ? project.calculation_cost : 0 | realCurrency }}</div>
                    </div>

                    <div class="divider" style="margin:10px 0;"></div>

                    <div class="line total">
                        <div class="left">Forv. dækningsbidrag</div>
                        <div class="right" :class="{'good': project.calculation_coverage > 0, 'bad': project.calculation_coverage < 0}">{{ project.calculation_coverage ? project.calculation_coverage : 0 | realCurrency }}</div>
                    </div>

            </template>
        </v-popover>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .tooltip-target {
        opacity: .5;

        &:hover {
            opacity: 1;
        }
    }

    .line {
        min-width: 250px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: $margin--small / 2;
        font-weight: 600;

        .good {
            color: $color--good;
        }

        .bad {
            color: $color--bad;
        }

        &.total {
            color: inherit;
            margin-bottom: 0;
            font-weight: 700;
        }
    }

</style>

<script>
export default {
    props: ['project'],
    data () {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// BudgetTooltip.vue?50a42f32